import {ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {SubSink} from 'subsink';
import {distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-multishare-history-search',
  template: `
    <div [formGroup]="multishareHistorySearchForm" class="multishare-history-entries-container">
      <div class="search-field-wrapper">
        <mat-form-field id="input-performedBy">
          <input formControlName="performedBy"
                 matInput
                 autocomplete="off"
                 name="input-performedBy"
                 placeholder="Performed By"/>
        </mat-form-field>
        <mat-form-field id="input-search">
          <input matInput type="datetime-local" placeholder="To" formControlName="dateTo">
        </mat-form-field>
        <button id="btn-clear-search"
                color="primary"
                class="clear-search-form-button"
                mat-raised-button
                (click)="clearSearch()">Clear
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./multishare-history-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultishareHistorySearchComponent implements OnInit, OnDestroy {
  @Output() searchForm = new EventEmitter();
  multishareHistorySearchForm = new FormGroup({
    performedBy: new FormControl(),
    dateFrom: new FormControl(),
    dateTo: new FormControl()
  });
  subsink = new SubSink();

  ngOnInit(): void {
    this.subsink.sink = this.multishareHistorySearchForm.valueChanges.pipe(
      distinctUntilChanged()
    ).subscribe((value) => {
      this.searchForm.emit(value);
    });
  }

  clearSearch() {
    this.multishareHistorySearchForm.patchValue({});
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

}
